module.exports = "/_next/static/images/gw-50cec7fde0d6e7416dd8e3602c0b1624.svg";